//  @ts-nocheck
import React, {
  useContext,
  useEffect,
  useRef,
  useState,
  CSSProperties,
} from "react";
import "./gallery-list.scss";
import AllForTag from "../GalleryHome/AllForTag";
import AllForColumn1 from "./AllForColumn1";
import AllForColumn2 from "./AllForColumn2";
import AllForColumn4 from "./AllForColumn4";
import AllForWaterfall from "./AllForWaterfall";
import { getElementTop } from "../../utils/dom";
import { getWatermarks, throttle, getLocalConfig } from "../../utils/util";
import { IComponentPhoto } from "../../component";
import ImageUtil, { style } from "../../utils/image";
import { IOneGallery } from "./Common";
import formatFlowList from "./formatFlowList";
import moment from "moment";
import Timeline from "./Timeline";
import { inject, observer } from "mobx-react";
import RootStore from "../../store/RootStore";
import { ThemeContext } from "../../store/ThemeProvider";
import AllForPeopleList from "./AllForPeopleList";
import NoX from "../Common/NoX";
import { IJigsaw } from "../../store/GalleryStore";
import { useGalleryInstance } from "./GalleryInstanceContext";
import Indicator from "../GalleryHome/Indicator";
import intl from "react-intl-universal";
import useScrollFixElement from "../hooks/useScrollFixElement";
import chroma from "chroma-js";
import { setContainer } from "../../utils/dom";

interface IAllForGalleryList {
  list: IOneGallery[];
  onClick: ({ index, id }: { index?: number; id: number }) => void;
  component: IComponentPhoto;
  rootStore?: RootStore;
  total?: number;
  jigsaw?: IJigsaw;
}

const PayRule = ()=>{
  const [fold, setFold] = useState(true);
  const themeContext = useContext(ThemeContext);

  const onClick = ()=>{
    setFold(!fold);
  };

  const arrowClass = `a-r ${fold ? 'more' : ''}`;

  return <div className="photo-pay-tooltip" style={{borderColor:themeContext.h2Color}}>
    <div className="tooltip-title" style={{color:themeContext.mainColor}}>
      <div className="title-row">{intl.get('GalleryPayTitle')}</div>
      <div className={'title-oper'} onClick={onClick}>
        <img
          src={require('../../assets/arrow-right.png')}
          alt=""
          className={arrowClass}
        />
      </div>
    </div>
    <div className="tooltip-desc" style={{color:themeContext.h2Color, display:fold ? 'block' : 'none'}}>
      <div className="desc-row">{intl.get('PayRule1')}</div>
      <div className="desc-row">{intl.get('PayRule2')}</div>
      <div className="desc-row">{intl.get('PayRule3')}</div>
    </div>
  </div>;
};

const AllForGalleryList = function (props: IAllForGalleryList) {
  // const tagRef = useRef<HTMLElement>(null);
  const themeContext = useContext(ThemeContext);
  const instanceStore = useGalleryInstance();
  const { redPackStore, uiStore, wxuserStore} = props.rootStore!;
  const { jigsaw, component } = props;
  // const { isFixed } = useScrollFixElement({
  //   elementRef: tagRef,
  //   scrollMoreThanCurrentCB: galleryStore.setTagRefTop,
  // });

  const [disableTag, setDisableTag] = useState(false);
  const [disableSystem, setDisableSystem] = useState(false);
  const [showDefaultTag, setShowDefaultTag] = useState({
    showall:true,
    showperson:true,
    showhot:true
  } as {
    [key: string]: boolean;
  });

  useEffect(() => {
    // 尴尬，后端居然可能没有返回mode
    const {
      mode = "1",
      disabletag = false,
      disablesystem = false,
      showall,
      showperson,
      showhot
    } = props.component;

    const config = getLocalConfig();
    if(config && config.mode && config.mode != 'system') {
      instanceStore.setMode(config.mode);
    }else {
      instanceStore.setMode(mode);
    }
    if(config && config.order && config.order != 'system') {
      instanceStore.setOrder(config.order);
    }
    setDisableTag(disabletag);
    setDisableSystem(disablesystem);
    setShowDefaultTag({
      ...showDefaultTag,
      showall:typeof showall != 'undefined' ? showall : true,
      showperson: typeof showperson != 'undefined' ? showperson : true,
      showhot: typeof showhot != 'undefined' ? showhot : true
    });
  }, []);

  useEffect(() => {
    // 需要监听两个事件
    // const tabIndexChange = (e: Event) => {
    //   const { action } = e;
    //   if (action) {
    //     if (action == "tab_has_photo") {
    //       const { mode = "1", disabletag = false } = props.component;
    //       setDisableTag(disabletag);
    //     }
    //     if (action == "tab_no_photo") {
    //       setDisableTag(true);
    //     }
    //   }
    // };
    // window.addEventListener("PENDENT_CHANGE", tabIndexChange);

    // return () => {
    //   window.removeEventListener("PENDENT_CHANGE", tabIndexChange);
    // };
  }, []);

  const currentGalleryData = window.dataDetail ? window.dataDetail : window.gallery;
  const usePay = Number(currentGalleryData.is_pay_down) > 0;

  // 检查当前相册，是否为付费相册
  useEffect(()=>{
    if(usePay) {
      // 判断一下各种数据都是正确的，再进行下一步
      // 请求当前支付列表
      wxuserStore.getCurrentPayGood(Number(currentGalleryData.is_pay_down));
      wxuserStore.getCurrentPayedImages(Number(currentGalleryData.id));
    }
  }, []);

  const onImageClick = ({ id, index }: {id: number; index?: number}) =>{
    const { jigsaw } = instanceStore;
    const { bottomShow } = jigsaw;

    if(!bottomShow) {
      if(usePay) {
        // 判断当前是否哪种付费模式
        const currentGood = wxuserStore.currentPayGood[String(currentGalleryData.is_pay_down)];
        if(currentGood && currentGood.type == 'download_photo') {
          // 判断当前id是否在已付费列表里
          const notPayed = wxuserStore.getNotPayed([Number(id)]);
          // let notPayed = [id];
          if(notPayed && notPayed.length) {
            // 还要检查是否登录了
            if(wxuserStore.user.is_mock) {
              return wxuserStore.auth();
            }
            // 弹出付费
            uiStore.showToast({ content: intl.get("ReadyToPay") });
            return wxuserStore.payToImage(currentGalleryData.id, Number(currentGalleryData.is_pay_down), window.pageDetail.link_id, notPayed);
          }
        }
      }
    }

    props.onClick({ id, index });
  };

  const refreshPhotoList = () => {
    const oldTotal = instanceStore.total;

    // @ts-ignore
    instanceStore.loadPic({ notmerge: true }).then((res: any) => {
      if (res && res.total) {
        if (oldTotal >= res.total) {
          uiStore.showToast({ content: intl.get("NoMorePhoto") });
        } else {
          uiStore.showToast({
            content: intl.get("MorePhoto", {
              num: res.total - oldTotal,
            }),
          });
        }
      }
    });
  };

  const renderFlowList = () => {
    const { start_time, end_time } = window.dataDetail
      ? window.dataDetail
      : window.gallery;
    const flowList = formatFlowList(props.list, {
      sorttype:
        (window.configDetail.sort || "").replace("-", "") || "shoottime",
      order: instanceStore.order,
      starttime: moment(start_time).valueOf(),
      endtime: moment(end_time).valueOf(),
    });

    return (
      <>
        {flowList?.map((one: any, index: number) => {
          if (!one || !one.list || !one.list.length) {
            return null;
          }
          return (
            <div key={index} style={{ width: "100%" }}>
              <Timeline time={one.showName} />
              <AllForColumn4
                onClick={onImageClick}
                list={one.list}
                jigsaw={jigsaw}
              />
            </div>
          );
        })}
      </>
    );
  };

  const { mode, listIsPerson, personList, hot, hotList } = instanceStore;
  // 如果当前是人物，显示人物专有的样式结构
  const renderWhich = () => {
    if (listIsPerson) {
      return <AllForPeopleList personList={personList} />;
    }
    // Hot使用2列的方式进行渲染
    if (hot) {
      // jigsaw 决定了拼图是否可用，所以需要传过去才行
      return (
        <AllForWaterfall
          onClick={onImageClick}
          list={hotList}
          isHot={true}
          jigsaw={jigsaw}
        />
      );
    }

    return (
      <>
        {mode === "1" && (
          <AllForColumn1
            list={props.list}
            onClick={onImageClick}
            jigsaw={jigsaw}
          />
        )}
        {mode === "2" && (
          <AllForColumn2
            list={props.list}
            onClick={onImageClick}
            jigsaw={jigsaw}
          />
        )}
        {mode === "4" && (
          <AllForColumn4
            onClick={onImageClick}
            list={props.list}
            jigsaw={jigsaw}
          />
        )}
        {mode === "flow" && renderFlowList()}
        {mode === "waterfall" && (
          <AllForWaterfall
            onClick={onImageClick}
            list={props.list}
            jigsaw={jigsaw}
          />
        )}
      </>
    );
  };

  const renderEmptyTip = () => {
    // 这里最优的处理是使用RedPackStore的服务器时间，毕竟本地时间的话，国际化上会有时区的问题
    const now = redPackStore.currentServerTime || new Date().getTime();
    const { start_time } = window.gallery;
    if (+start_time > now) {
      return intl.get("Waiting");
    }
    return intl.get("No photos");
  };

  const currentPayGood = usePay ? wxuserStore.currentPayGood[String(currentGalleryData.is_pay_down)] : null;

  const componentStyle = setContainer(
    props.component,
    themeContext.componentColor
  ) as CSSProperties;
  return (
    <div
      className={`gallery-list-component comp_${props.component.cid}`}
      style={{
        backgroundColor: themeContext.componentColor,
        // paddingTop: disableTag ? 0 : 40,
        position: "relative", // 必须是定位元素，否则Tags会无法正常定位
        minHeight: "70vh",
        ...componentStyle,
      }}
    >
      {currentPayGood ? <PayRule /> : null}
      {disableTag ? null : (
        <AllForTag
          // ref={tagRef}
          // isFixed={isFixed}
          loadPic={instanceStore.loadPic}
          disableSystem={disableSystem}
          {...showDefaultTag}
        />
      )}
      {props.total === 0 || (listIsPerson && personList.length === 0) ? (
        <NoX text={renderEmptyTip()} />
      ) : (
        <>
          {/*此处显示的是新增照片模块*/}
          {instanceStore.morePhoto ? (
            <div
              className="photo-refresh-wrapper"
              style={{
                color: chroma(themeContext.h1Color).alpha(0.6).css(),
              }}
              onClick={refreshPhotoList}
            >
              {`${intl.get(`MorePhoto`, {
                num: instanceStore.morePhoto,
              })}，${intl.get("ClickRefresh")}`}
            </div>
          ) : null}
          <div
            className="gallery-list"
            style={{ backgroundColor: themeContext.componentColor }}
          >
            {renderWhich()}
          </div>
        </>
      )}
    </div>
  );
};

export default inject("rootStore")(observer(AllForGalleryList));
